import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { refreshUserToken } from '../../actions/authentication';

export class TokenPage extends React.Component {
  static propTypes = {
    authentication: PropTypes.object.isRequired,
    refreshTokenAction: PropTypes.func.isRequired,
  };

  refreshToken = evt => {
    evt.preventDefault();
    const { refreshTokenAction } = this.props;
    refreshTokenAction();
  };

  renderUserInfo = authentication => (
    <div>
      <p>
        Token:<input type="text" value={authentication.token} readOnly />{' '}
      </p>
      <p>
        <button className="link-button" onClick={this.refreshToken}>
          Refresh Token
        </button>
      </p>
    </div>
  );

  renderLoginLink = () => (
    <div>
      <p>
        You have no session token at this time. Please <Link to="/account/login">Log In</Link> to
        fix that.
      </p>
    </div>
  );

  render() {
    const { authentication } = this.props;
    const { token } = authentication;

    return (
      <div>
        <h1>Token</h1>
        <p>
          Note: This page will most likely be removed prior to launch.
          <i className="fa fa-rocket" aria-hidden="true" />&nbsp;
          <i className="fa fa-hand-peace-o" aria-hidden="true" />
        </p>
        {token ? this.renderUserInfo(authentication) : this.renderLoginLink()}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { authentication } = state;
  return { authentication };
}

export default connect(mapStateToProps, {
  refreshTokenAction: refreshUserToken,
})(TokenPage);
